module.exports = __webpack_public_path__ + "img/examples-en-7.37202e69.jpg";